import $ from 'jquery';
import './slick-carousel';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

// import slick from 'slick-carousel';
// Expose the function as a jQuery plugin for ease of use
// Expose the function as a jQuery plugin for ease of use
/**
* Merges together all the options and the various conditions in which they
* can be set.
* @param  {jQuery} $el - The container element
* @param  {Object} [options={}] - Any options provided upon initialization
* @return {Object} Immutable version of the options
*/

const initSlick = ($carouselTrack, options = { }) => {
  $carouselTrack.slick({
    arrows: false,
    infinite: options.infinite,
    slidesToShow: options.numSlides,
    slidesToScroll: 1,
    touchThreshold: 20,
  });
};
const getTrack = $el => $el.find('.slick-carousel, .slick-carousel--extend').css({ display: 'block' });
export const PLUGIN_NAME = 'slickSlider';
export const DEFAULTS = {
  infinite: true,
  numSlides: 3,
};
export default function slickSlider(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  const $carouselTrack = getTrack($el);
  initSlick($carouselTrack, opts);
}
registerJQueryPlugin(PLUGIN_NAME, slickSlider);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slick-slider.js